import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Card, Form, Button, Modal, Alert } from "react-bootstrap";
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';          // Role
import VerifiedIcon from '@mui/icons-material/Verified';  // Status
import BadgeIcon from '@mui/icons-material/Badge';        // CNIC
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'; // Mobile
import TotalGroupsRecord from "./TotalGroupsRecord";
import PageLayout from "../../layouts/PageLayout";
import {  useParams } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import axios from "axios";
import moment from "moment";import { Group } from "antd/es/radio";
function ViewGroupMembers() {

      const { t, n } = useContext(TranslatorContext);
    
    return (
        <>


        <PageLayout>


      <Row>
         <Col xl={12}>
                  <div className="mc-card">
                    <div className="mc-breadcrumb">
                      <h3 className="mc-breadcrumb-title">Group: [{Group.id}]</h3>
                      <ul className="mc-breadcrumb-list">
                        <li className="mc-breadcrumb-item">
                          <Link to="#" className="mc-breadcrumb-link"style={{color:"#077834"}}>
                            {t("home")}
                          </Link>
                        </li>
                         <li className="mc-breadcrumb-item">
                          <Link to="#" className="mc-breadcrumb-link"style={{color:"#077834"}}>
                            {t("ACT Group Dashboard")}
                          </Link>
                        </li>
                        <li className="mc-breadcrumb-item">
                          <Link to="#" className="mc-breadcrumb-link"style={{color:"#077834"}}>
                            {t("Groups")}
                          </Link>
                        </li>
                        <li className="mc-breadcrumb-item">Group Members</li>
                      </ul>
                    </div>
                  </div>
                  
                </Col>
      </Row>


<Row>
    <Col xs={12} sm={12} md={12} lg={12}xl={12} className="">

    <Card className="mc-card mb-4">
  <Card.Body>
    <h5 className="mb-3">Member Details | <span>member-id</span></h5>

    <div className="main-div d-flex justify-content-between mb-3">
      <div className="left-div"> 
        <div className="mb-2"><PersonIcon /> <strong>Name:</strong> Ammey
    </div>
    <div className="mb-2"><WorkIcon /> <strong>Role:</strong> president
    </div></div>

    <div className="right-div">
<div className="mb-2">
     <VerifiedIcon color="success" /> <strong>Status:</strong> active
    </div>
    </div>

       </div>
<div className="break bg-dark"></div>
<br/>
    <div>
        <div className="mb-2">
      <BadgeIcon /> <strong>CNIC:</strong> 23401-456780-112
    </div>
    <div className="mb-2">
      <PhoneAndroidIcon /> <strong>Mobile:</strong> 030078654311
    </div>
    </div>
  
  </Card.Body>
</Card>

</Col>
</Row>
        </PageLayout>
        </>
    )
}

export default ViewGroupMembers
